var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1B1D1E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64 6.502l.81-.585 1.51-1.088v7.67h2V4.827l1.539 1.094.815.58 1.159-1.63-.815-.58-3.088-2.194a1.07 1.07 0 00-1.245.004L8.28 4.295l-.811.585 1.17 1.622zm8.33 4.428a7.024 7.024 0 001.215-1.65l.01.01a6.943 6.943 0 011.733 3.383c.788.237 1.499.69 2.042 1.318.718.83 1.086 1.9 1.023 2.993a4.222 4.222 0 01-1.36 2.858A4.394 4.394 0 0118.665 21l-1.002.002v-.004H6.34a5.518 5.518 0 01-3.773-1.596A5.283 5.283 0 011 15.657c0-1.405.565-2.748 1.566-3.744a5.518 5.518 0 013.773-1.596h.023l.128.001a7.038 7.038 0 001.724 1.57l-.333.682-.77-.17a3.499 3.499 0 00-.74-.084 3.518 3.518 0 00-2.394 1.014A3.283 3.283 0 003 15.657c0 .865.348 1.7.977 2.327a3.517 3.517 0 002.395 1.014h12.385a2.392 2.392 0 001.52-.626c.432-.398.687-.937.72-1.504a2.203 2.203 0 00-.54-1.569 2.373 2.373 0 00-1.531-.798l-.816-.091-.07-.818a4.912 4.912 0 00-1.07-2.662z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.bc972a65.svg";
export { ForwardRef as ReactComponent };